import React from "react";

const AboutMe = () => {
  return (
    <div className="flex flex-col md:flex-row pb-6">
      <div className="w-full md:w-1/2 text-zinc-400 px-6 border-r-[1px] border-r-zinc-800 flex items-center">
        <div className="py-6">
          <h2 className="font-semibold mb-1">Hi! I'm Rangga Gunarto</h2>
          <p className="text-base leading-6 ">
            I'm an aspiring Computer Systems Engineer currently doing my A-Levels in Malaysia, currently skilled and specialized in Systems Engineering, High-Performance Graphics and 3D Modelling 
          </p>
        </div>
      </div>
      <div className="w-full md:w-1/2 p-6">
        <ul className="flex flex-col gap-1">
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Age:</span>
            18
          </li>
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Residence:</span>
            Malaysia
          </li>
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Freelance:</span>
            Atlassian Studios
          </li>
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Address:</span>
            KL, Malaysia
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AboutMe;
